import { ApiUtil as api } from '@/utils/api.util.js'

export class CodeService {
  static URL = process.env.API_URL + process.env.API_VER
  static RESOURCE = '/codes/'

  static all(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams)
  }

  static chained(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'chained', queryParams)
  }

  static childIntersection(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'child-intersection', queryParams)
  }

  static create(queryParams = {}) {
    return api.post(this.URL + this.RESOURCE, queryParams)
  }

  static show(id, queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + id, queryParams)
  }

  static update(id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id, queryParams)
  }

  static delete(id) {
    return api.delete(this.URL + this.RESOURCE + id)
  }

  static listTypes(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'types', queryParams)
  }

  static getChildren(code_id, queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + code_id + '/codes', queryParams);
  }

  static syncChildren(id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/sync-codes', queryParams);
  }

  static detachChildren(id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/detach-codes', queryParams);
  }

  static toggleChidren(id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/toggle-codes', queryParams);
  }

  static syncParentsChilds(queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + 'parent-child', queryParams);
  }

  static associateCodes(codeIds = [], queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + 'associate-codes', { ...queryParams, code_ids: codeIds });
  }

  static validateAssociations(codeIds = [], queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'validate-associations', { ...queryParams, code_ids: codeIds });
  }

  static updateAttribute(id, attributeId, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + id + '/attributes/' + attributeId, queryParams);
  }
  static archive (queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + 'firm/firm/archive/', queryParams)
  }

  static bulkArchive (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'firm/firm/bulk-archive/', queryParams)
  }
  static bulkRestore (queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'firm/firm/bulk-restore/', queryParams)
  }
  static firmFirmCodes(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'firm/firm/codes', queryParams);
  }
  static uploadData (id, queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'firm/firm/upload-data/' + id, queryParams)
  }
  static import(queryParams = {}) {
    return api.post(this.URL + this.RESOURCE + 'import', queryParams)
  }
  static getCodeTag(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'code/code-tag', queryParams);
  }
  static getDropdownCodes(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + 'code/dropdown-codes', queryParams);
  }
  static assignToggle(queryParams = {}) {
      return api.post(this.URL + this.RESOURCE + 'assign-toggle', queryParams)
  }
  static codeByType(queryParams = {}) {
      return api.get(this.URL + this.RESOURCE + 'code/type', queryParams)
  }

  static archiveTags(id, data = {}) {
		return api.put(this.URL + this.RESOURCE + id + '/archive-tags', data);
	}

	static restoreTags(id, data = {}) {
		return api.put(this.URL + this.RESOURCE + id + '/restore-tags', data);
	}
}



// WEBPACK FOOTER //
// ./src/services/code.service.js